import { render, staticRenderFns } from "./likes.vue?vue&type=template&id=e99174b4&"
import script from "./likes.vue?vue&type=script&lang=ts&"
export * from "./likes.vue?vue&type=script&lang=ts&"
import style0 from "./likes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports